import React, { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import ProductList from "../../ProductList";
import { ImgIcon } from "../../../assets";
import { updateShopProduct, createShopProduct } from "../../../actions/shop";
import { payloadToFormData } from "../../../helpers";
import { useModal } from "../../../assets/useModal";
import { edit, visible, hidden } from "../../../assets/icons";
import ProductEditor from "./ProductEditor";

export default function ProductManager() {

	const { setModal, openModal, closeModal, configModal } = useModal();
	const dispatch = useDispatch();
	const { creating, products } = useSelector(state => ({
		creating: state.shop.creating,
		products: state.shop.products
	}));
	const categories = useMemo(() => [...new Set(products.map(p => p.category))].filter(c => c), [products]);

	const [editing, setEditing] = useState(null);

	useEffect(() => {
		if (editing) {
			const product = products.find(p => p.id === editing);
			if (!product) return;
			const variants = products.filter(p => p.parent === product.id);
			setModal((
				<ProductEditor
					key={editing}
					product={product}
					variants={variants}
					categories={categories}
					onExit={closeModal}
				/>
			));
			configModal({ closable: false });
		} else {
			setModal(null);
			configModal({ closable: true });
		}
	}, [editing, products, categories, setModal, configModal, closeModal]);

	return <div className="productManager">
		<ProductList
			branded={false}
			products={products}
			renderProduct={product => {
				const variants = products.filter(p => p.parent === product.id);
				return <div
					className="product product-summary featureFont flexy"
					key={product.id}
					onClick={e => {
						setEditing(product.id);
						openModal();
					}}
				>
					<div style={{ flex: 3 }}>
						<div>
							<b className="d-inline-block">{product.name}</b>
							{Boolean(variants.length) && <span
								className="variant-summary brand-c d-inline-block"
								style={{ marginLeft: 8 }}
							>
								+{variants.length} variant{variants.length !== 1 && "s"}
							</span>}
						</div>
					</div>
					<div style={{ flex: 2 }} >£{(product.price / 100).toFixed(2)}</div>
					<div style={{ flex: 1 }} className="controls">
						<ImgIcon
							src={edit}
							size={30}
							bg={"#f7f7f7"}
							iconSize={"70%"}
							onClick={e => { }}
						/>
						<ImgIcon
							className="brand-bg"
							title={product.available ? "This product is available. Click to hide." : "This product is hidden. Click to make available."}
							src={product.available ? visible : hidden}
							size={30}
							iconSize={"70%"}
							style={!product.available ? {
								backgroundColor: "#f7f7f7"
							} : {}}
							onClick={e => {
								e.stopPropagation();
								dispatch(updateShopProduct(product.id, { available: !product.available }));
							}}
						/>
					</div>
				</div>
			}}
		/>
		<section>
			<br />
			<h4>Add a new product</h4>
			<div className="inner">
				Create a new product using the tool below. To create a product, the following fields <b>must</b> be completed:
				<ul>
					<li>Name.</li>
					<li>Price - <b>£0.00 isn't allowed</b>.</li>
					<li>Category - <b>an existing one, or a new one</b>.</li>
				</ul>
				Once you've created the product it will appear in your product list above. Then you can edit it further, or add variants for alternate versions.
				<br /><br />
			</div>
		</section>
		<section>
			<div className="inner">
				<ProductEditor
					product={{ loading: creating }}
					categories={categories}
					onSave={newProduct => {
						const formData = payloadToFormData(newProduct);
						dispatch(createShopProduct(formData));
					}}
				/>
			</div>
		</section>
	</div>
}